import React from "react";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { graphql, useStaticQuery } from "gatsby";

import TestimonialCard from "../components/TestimonialCard";

const BuyerTestimonials: React.FC = () => {
  const data = useStaticQuery<Queries.BuyerTestimonialsQuery>(query);

  return (
    <div className="mb-16 bg-black">
      <div className="mx-auto max-w-[1200px] px-4 py-6 lg:flex lg:items-center lg:justify-between">
        <div className="mb-6">
          <h1 className="mb-1 text-4xl font-semibold text-white">
            Proven Results
          </h1>
          <h4 className="text-xl text-white">from satisfied buyers</h4>
        </div>
        <div className="relative max-w-[760px] pb-10 lg:flex lg:items-center lg:pb-0 lg:pr-6">
          <CarouselProvider
            infinite
            interval={20000}
            isPlaying={true}
            dragEnabled={false}
            touchEnabled={false}
            naturalSlideHeight={1}
            naturalSlideWidth={1.5}
            isIntrinsicHeight={true}
            totalSlides={data.testimonials.nodes.length}
            className="w-full"
          >
            <ButtonBack className="absolute bottom-0 right-16 z-10 lg:-left-8 lg:bottom-auto lg:top-[calc(50%-24px)]">
              <MdChevronLeft className="h-8 w-8 fill-clhbid-orange transition-colors hover:cursor-pointer hover:fill-clhbid-orange-dark" />
            </ButtonBack>
            <Slider classNameTrayWrap="py-2">
              {data.testimonials.nodes.map((testimonial, i) => (
                <Slide
                  key={testimonial.name}
                  index={i}
                  className="px-2"
                  innerClassName="flex items-center"
                >
                  <TestimonialCard
                    testimonial={testimonial}
                    className="border border-clhbid-orange"
                  />
                </Slide>
              ))}
            </Slider>
            <ButtonNext className="absolute bottom-0 right-0 z-10 lg:-right-2 lg:bottom-auto lg:top-[calc(50%-24px)]">
              <MdChevronRight className="h-8 w-8 fill-clhbid-orange transition-colors hover:cursor-pointer hover:fill-clhbid-orange-dark" />
            </ButtonNext>
          </CarouselProvider>
        </div>
      </div>
    </div>
  );
};

const query = graphql`
  query BuyerTestimonials {
    testimonials: allTestimonialsYaml(
      filter: { priority: { eq: true }, type: { in: ["buyer", "both"] } }
    ) {
      nodes {
        ...TestimonialCardTestimonial
      }
    }
  }
`;

export default BuyerTestimonials;
